export const hasPermission = (permissions = [], permission) => {
  if (!permission) return true;
  return permissions.includes(permission);
};

export const filterSidebarByPermission = (sidebar = [], permissions = []) => {
  return sidebar
    .map((item) => {

      // If menu has children
      if (item.children && item.children.length > 0) {

        const filteredChildren = item.children.filter((child) =>
          hasPermission(permissions, child.permission)
        );

        // Show parent if at least one child allowed
        if (filteredChildren.length > 0) {
          return {
            ...item,
            children: filteredChildren,
          };
          
        }

        return null;
      }

      // If no children
      if (hasPermission(permissions, item.permission)) {
        return item;
      }

      return null;
    })
    .filter(Boolean);
};


/**
 * Check if user has ANY permission from list
 */
export const hasAnyPermission = (permissions = [], permissionList = []) => {
  return permissionList.some((perm) => permissions.includes(perm));
};


/**
 * Check if user has ALL permissions from list
 */
export const hasAllPermissions = (permissions = [], permissionList = []) => {
  return permissionList.every((perm) => permissions.includes(perm));
};